/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Upload_AttributionInputs */



/**
* | output |
* | --- |
* | "Attribution" |
*
* @param {Deck_Upload_AttributionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_upload_attribution = /** @type {((inputs?: Deck_Upload_AttributionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Upload_AttributionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Attribution")
	if (locale === "es") return /** @type {LocalizedString} */ ("Atribución")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Atribuição")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attribuzione")
	return /** @type {LocalizedString} */ ("Attribution")
});